import { useMemo, useState } from "react";
import { numeroWhatsApp } from "../../data/produto.js";
import "./Contato.css";

const instagramUrl = "https://www.instagram.com/repiqueesporas";
const contatoEmail = "repiqueesporasloja@gmail.com";

export default function Contato() {
  const [nome, setNome] = useState("");
  const [telefone, setTelefone] = useState("");
  const [assunto, setAssunto] = useState("");
  const [mensagem, setMensagem] = useState("");

  const telefoneFormatado = useMemo(() => {
    return `+55 ${numeroWhatsApp.slice(2, 4)} ${numeroWhatsApp.slice(4, 6)} ${numeroWhatsApp.slice(6, 10)} ${numeroWhatsApp.slice(10)}`;
  }, []);

  const handleSubmit = (event) => {
    event.preventDefault();
    const mailSubject = assunto || "Contato pelo site - Repique Esporas";
    const mailBody =
      `Nome: ${nome || "Não informado"}\n` +
      `WhatsApp: ${telefone || "Não informado"}\n\n` +
      `Mensagem:\n${mensagem || ""}`;

    const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(contatoEmail)}&su=${encodeURIComponent(
      mailSubject,
    )}&body=${encodeURIComponent(mailBody)}`;

    window.open(gmailUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <section className="pagina-contato">
      <div className="contato-hero">
        <div className="contato-hero-texto">
          <span className="secao-etiqueta">Fale com a gente</span>
          <h1>Estamos prontos para tirar sua dúvida sobre nossos produtos!</h1>
          <p>
            Entre em contato pelo WhatsApp ou Instagram e receba um atendimento
            rápido, personalizado e com toda a atenção que sua espora merece.
          </p>
        </div>
        <div className="contato-hero-card">
          <div className="contato-card-item">
            <strong>WhatsApp</strong>
            <a
              href={`https://wa.me/${numeroWhatsApp}`}
              target="_blank"
              rel="noreferrer"
            >
              {telefoneFormatado}
            </a>
          </div>
          <div className="contato-card-item">
            <strong>E-mail</strong>
            <a
              href={`https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(
                contatoEmail,
              )}`}
              target="_blank"
              rel="noreferrer"
            >
              {contatoEmail}
            </a>
          </div>
          <div className="contato-card-item">
            <strong>Instagram</strong>
            <a href={instagramUrl} target="_blank" rel="noreferrer">
              @repiqueesporas
            </a>
          </div>
        </div>
      </div>

      <div className="contato-grid">
        <div className="contato-formulario">
          <h2>Envie sua mensagem via e-mail!</h2>
          <p>
            Use o formulário abaixo para nos contar o que você deseja: pedido de
            espora personalizada, orçamento ou dúvida sobre materiais. A sua
            mensagem será aberta diretamente por e-mail para resposta rápida.
          </p>
          <form className="form-contato" onSubmit={handleSubmit}>
            <label>
              Nome completo
              <input
                type="text"
                placeholder="Seu nome"
                value={nome}
                onChange={(event) => setNome(event.target.value)}
              />
            </label>
            <label>
              WhatsApp ou telefone
              <input
                type="tel"
                placeholder="(99) 9 9999-9999"
                value={telefone}
                onChange={(event) => setTelefone(event.target.value)}
              />
            </label>
            <label>
              Assunto
              <input
                type="text"
                placeholder="Ex: Montar espora, pedido, dúvida"
                value={assunto}
                onChange={(event) => setAssunto(event.target.value)}
              />
            </label>
            <label>
              Mensagem
              <textarea
                placeholder="Me conte o que precisa..."
                rows="5"
                value={mensagem}
                onChange={(event) => setMensagem(event.target.value)}
              />
            </label>
            <button type="submit" className="btn-contato-enviar">
              Enviar mensagem
            </button>
          </form>
        </div>

        <div className="contato-extras">
          <div className="contato-extras-card">
            <h3>O que podemos te ajudar</h3>
            <ul>
              <li>Montar sua espora personalizada</li>
              <li>Selecionar corpo, papagaio e roseta</li>
              <li>Receber orçamento rápido</li>
              <li>Informações sobre prazo e entrega</li>
            </ul>
          </div>

          <div className="contato-extras-card destaque">
            <h3>Fale diretamente agora</h3>
            <p>
              Clique no botão abaixo para iniciar o atendimento via WhatsApp e
              mostrar as referências da sua espora.
            </p>
            <a
              className="btn-contato-whats"
              href={`https://wa.me/${numeroWhatsApp}?text=${encodeURIComponent(
                "Olá! Quero um orçamento e ajuda para montar minha espora personalizada.",
              )}`}
              target="_blank"
              rel="noreferrer"
            >
              Abrir WhatsApp
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
